import * as React from 'react';
import {FunctionComponent, useState} from 'react';
import {GeoTrack} from '../../../../Models/GeoTrack';
import {GeoTrackMapColored, MapSegment} from './GeoTrackMapColored';
import {Bucket} from '../../Utils/Bucket';
import {formatSplit} from '../../../Support/Formatting/formatSplit';
import {formatDuration} from '../../../Support/Formatting/formatDuration';
import {GeoPointRangeSelector} from './GeoPointRangeSelector';
import {GeoTrackInterval, IntervalType} from '../../../../Geo/geoTrackToIntervals';
import {Duration} from '../../../../Domain/Duration';
import {GeoPoint} from '../../../../Models/GeoPoint';

interface OwnProps {
    intervals: GeoTrackInterval[];
}

export const GeoTrackAnalyzer: FunctionComponent<OwnProps> = ({intervals}) => {
    // Create MapSections from GeoTrackIntervals.
    const mapSections: MapSegment[] = [];
    let elapsedTime: Duration = Duration.fromSeconds(0);
    for (const interval of intervals) {
        for (const section of interval.segments) {
            elapsedTime = elapsedTime.add(section.duration);
            mapSections.push({
                ...section,
                isRest: interval.type === IntervalType.Rest,
                speed: section.speed,
                elapsedTime: elapsedTime,
            });
        }
    }

    // Create GeoTrack from Intervals.
    const geoTrack: GeoTrack = intervals
        .map((i) => i.segments)
        .flat()
        .map((s) => s.from);
    const [selectedGeoPoint, setSelectedGeoPoint] = useState<GeoPoint | undefined>(geoTrack[0]);
    const selectedMapSection: MapSegment | undefined = mapSections.filter((s) => s.from === selectedGeoPoint)[0];

    return (
        <div className="card mt-3">
            <div className="card-title">
                <h5>Map</h5>
            </div>
            <div className="card-bodygraphs">
                <div className="row">
                    <div className="col-12">
                        <GeoTrackMapColored
                            height={400}
                            sections={mapSections}
                            selectedGeoPoint={selectedGeoPoint}
                            onGeoPointClicked={setSelectedGeoPoint}
                        />
                    </div>
                </div>
            </div>
            <div className="card-body">
                <div className="row d-flex flex-column gap-2">
                    <div className="col-12 d-flex flex-row gap-2 flex-wrap">
                        <Bucket value={formatDuration(selectedGeoPoint?.elapsed_time || null)} label="Time" />
                        <Bucket value={formatSplit(selectedMapSection?.speed || null)} label="Split" />
                    </div>
                </div>
            </div>
            <div className="card-body">
                <GeoPointRangeSelector
                    geoTrack={geoTrack}
                    selectedGeoPoint={selectedGeoPoint}
                    onGeoPointChanged={(geoPoint) => setSelectedGeoPoint(geoPoint)}
                />
            </div>
        </div>
    );
};
